<template>
  <svg :fill="color" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg">
    <path d="M10.31,1.54c-.48-1.16-1.75-1.78-2.96-1.45L1.84,1.59c-1.09.3-1.84,1.29-1.84,2.41,0,15.46,12.54,28,28,28,1.12,0,2.11-.76,2.41-1.84l1.5-5.5c.33-1.21-.29-2.48-1.45-2.96l-6-2.5c-1.02-.42-2.2-.13-2.89.72l-2.52,3.08c-4.4-2.08-7.96-5.64-10.04-10.04l3.08-2.52c.86-.7,1.15-1.88.73-2.89l-2.5-6h0Z"/>
  </svg>
</template>

<script>
export default {
  name: 'IconPhone',
  props: {
    color: {
      type: String,
      default: '#24b9ec'
    }
  }
}
</script>
